import React, { useState } from 'react';
import Link from 'next/link';
import css from './Footer.less';

const Footer = props => {
  const [linkList] = useState([
    { path: '/about', title: '关于我们' },
    { path: '/join', title: '加入我们' },
    { path: '/contact', title: '联系我们' },
    {
      path: 'http://www.xindebaby.com/thrid/providers/',
      title: '服务商入口',
    },
  ]);

  const [company] = useState({
    name: '北京新得科技有限公司',
    address: '北京市朝阳区八里庄西里98号住邦2000-3号楼2103',
    icp1: '京ICP证京B2-20170357',
    icp2: '京ICP备16013191号',
    icp3: '京公网安备11010502031656号',
    icp4: '互联网药品信息服务资格证编号(京)-经营性-2019-0029',
  });

  const [partnerStr] = useState(
    '本公司展示的保险产品均来自于以下四家中介类保险代理公司，并且进行了信息披露和报备。四家公司分别为：\n保通保险代理有限公司、慧择保险经纪有限公司、小雨伞保险经纪有限公司、科成保险代理有限公司。',
  );

  const { hasPartners } = props;
  return (
    <footer className={css.content}>
      <div className={`${css.contentMain} ${hasPartners && css.hasPartners}`}>
        {hasPartners ? (
          <div className={css.partners}>
            <p className={css.partnerStr}>{partnerStr}</p>
          </div>
        ) : null}
        <nav className={css.nav}>
          {linkList.map(item => {
            const hasHttp = item.path.indexOf('http') === 0;
            return (
              <React.Fragment key={item.title}>
                {item.path ? (
                  <React.Fragment key={item.title}>
                    {hasHttp ? (
                      <a
                        className={css.linkItem}
                        href={item.path}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.title}
                      </a>
                    ) : (
                      <Link href={item.path}>
                        <a className={css.linkItem}>{item.title}</a>
                      </Link>
                    )}
                  </React.Fragment>
                ) : (
                  <span className={css.linkItem}>{item.title}</span>
                )}
              </React.Fragment>
            );
          })}
        </nav>
        <div className={css.companyBox}>
          <div className={css.company}>
            <p>
              © {new Date().getFullYear()} {company.name} 版权所有
            </p>
            <p>{company.address}</p>
            <p>
              <span className={css.icpItem}>{company.icp1}</span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://beian.miit.gov.cn/"
                className={css.icpItem}
              >
                {company.icp2}
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502031655"
                className={css.icpItem}
              >
                {company.icp3}
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://weapp-assets.xindebaby.com/web_certificate_213.jpeg"
                className={css.icpItem}
              >
                {company.icp4}
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
